module.exports = __webpack_public_path__ + "static/img/main__download02.bab64db5.svg";